module.exports = __webpack_public_path__ + "static/media/heart_selected.1cddc92f.svg";